module.exports = __webpack_public_path__ + "media/lobby_selfintro.81bc9542.mp3";